import React, { createContext, useContext, useEffect, useState } from 'react'

interface INewPasswordContextState {
  isValidQuantidadeCaracteres: boolean
  isValidCaracterEspecial: boolean
  isValidCaracter: boolean
  isValidCaracterNumerico: boolean
  isPasswordValid: boolean
  newUserPassword: string
  setNewPassword: React.Dispatch<React.SetStateAction<string>>
  confirmPassword: string
  setConfirmPassword: React.Dispatch<React.SetStateAction<string>>
}

const NewPasswordContext = createContext<INewPasswordContextState>(
  {} as INewPasswordContextState,
)

export function useNewPassword(): INewPasswordContextState {
  const context = useContext(NewPasswordContext)

  if (!context) {
    throw new Error('useNewPassword must be used within an NewPasswordProvider')
  }

  return context
}

function hasNumber(txt) {
  const haveNumberRegex = /\d/g
  return haveNumberRegex.test(txt)
}

function hasChacarcter(txt) {
  const haveCharacterRegex = /[a-zA-Z]/g
  return haveCharacterRegex.test(txt)
}

function hasSpecialCharacter(txt) {
  const haveEspecialCharacterRegex = /[!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/?]+/
  return haveEspecialCharacterRegex.test(txt)
}

export const NewPasswordProvider: React.FC = ({ children }) => {
  const [isValidQuantidadeCaracteres, setIsValidQuantidadeCaracteres] =
    useState(false)
  const [isValidCaracterEspecial, setIsValidCaracterEspecial] = useState(false)
  const [isValidCaracter, setIsValidCaracter] = useState(false)
  const [isValidCaracterNumerico, setIsValidCaracterNumerico] = useState(false)
  const [isPasswordValid, setIsPasswordValid] = useState(false)
  const [newUserPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')

  const validateSecurityPassword = (password: string) => {
    setIsValidQuantidadeCaracteres(password.length > 7)
    setIsValidCaracterEspecial(hasSpecialCharacter(password))
    setIsValidCaracter(hasChacarcter(password))
    setIsValidCaracterNumerico(hasNumber(password))
  }

  useEffect(() => {
    validateSecurityPassword(newUserPassword)
    setIsPasswordValid(
      isValidQuantidadeCaracteres &&
        isValidCaracterEspecial &&
        isValidCaracter &&
        isValidCaracterNumerico &&
        newUserPassword === confirmPassword,
    )
  }, [
    newUserPassword,
    confirmPassword,
    isValidCaracter,
    isValidQuantidadeCaracteres,
    isValidCaracterNumerico,
    isValidCaracterEspecial,
  ])

  return (
    <NewPasswordContext.Provider
      value={{
        isValidQuantidadeCaracteres,
        isValidCaracterEspecial,
        isValidCaracter,
        isValidCaracterNumerico,
        isPasswordValid,
        newUserPassword,
        setNewPassword,
        confirmPassword,
        setConfirmPassword,
      }}
    >
      {children}
    </NewPasswordContext.Provider>
  )
}
